import { MicromedidorUltimaTransmision } from './../../../_entities/micromedidores/micromedidor';
import { ReporteMedidores } from './../../../_entities/medidores/ReporteMedidores';
import { Medidores } from './../../../_entities/medidores/Medidores';
import { environment } from './../../../../environments/environment';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Dashboard } from '../../../_entities/Dashboard';
import { Alertado } from './../../../_entities/consola/alertados';
import { Activo } from './../../../_entities/activos/activo';
import { Telefono } from './../../../_entities/telefonos/telefono';
import { GraficaPastel } from './../../../_entities/tablero/grafoca-pastel';
import { AuthService } from '../../auth/auth.service';
import {GraficasHw} from '../../../_entities/tablero/graficas-hw';
import { Portatil } from '../../../_entities/Portatiles/Portatil';

@Injectable({
	providedIn: 'root'
})
export class TablasService {

	constructor(private http: HttpClient, private auth: AuthService) { }

	getTotalVehiculosActivos(): Observable<Dashboard> {
		return this.http.get<Dashboard>(`${environment.API_SECURITY}/api/dashboard/GetTotalVehiculosActivos`);
	}

	getTotalVehiculosFueraGeocerca(): Observable<Dashboard> {
		/*let user = this.auth.getUser();
		let token = '0'
		if(user.id == 'c28df0c4-3322-421c-b601-8aa7e80536cf'  || user.id == '74bc5a50-65cd-4fa3-9a68-99886b468b6b') {
			token = token1
		}*/
		return this.http.get<Dashboard>(`${environment.API_SECURITY}/api/dashboard/GetTotalVehiculosFueraGeocerca`);
	}

	getTotalVehiculosMovimiento(): Observable<Dashboard> {
		return this.http.get<Dashboard>(`${environment.API_SECURITY}/api/dashboard/GetTotalVehiculosMovimiento`);
	}

	getTotalAlertados() {
		return this.http.get(environment.API_SECURITY + '/api/consola/VehiculosAlertadosDashboard', { responseType: 'text' });
	}

	obtenerActivos(): Observable<Activo[]> {
		return this.http.get<Activo[]>(environment.API_SECURITY + '/api/CrudActivos');
	}

	obtenerTelefonos(): Observable<Telefono[]> {
		return this.http.get<Telefono[]>(environment.API_SECURITY + '/api/Telefonos');
	}


	obtenerUltimoDatoMedidor(): Observable<any> {
		return this.http.get(environment.API_SECURITY + '/api/Medidores/ultimamedidor')
	}

	obtenerMedidores(): Observable<Medidores[]> {
		return this.http.get<Medidores[]>(environment.API_SECURITY + '/api/Medidores')
	}

	obtenerPortatiles():Observable<Portatil[]>{
		return this.http.get<Portatil[]>(environment.API_SECURITY+'/api/Portatiles')
	}

	obtenerReportePosicionesMedidores(medidorImei, fechaInicio, fechaFinal): Observable<ReporteMedidores[]> {
		return this.http.get<ReporteMedidores[]>(`${environment.API_SECURITY}/api/Medidores/${medidorImei}/reporte-historico?fechaInicio=${fechaInicio}&fechaFinal=${fechaFinal}`);
	}

	obtenerMicromedidores(): Observable<MicromedidorUltimaTransmision[]> {
		return this.http.get<MicromedidorUltimaTransmision[]>(environment.API_SECURITY + '/api/Micromedidores/Lecturas');
	}

	obtenerAlertasHowen(): Observable<number> {
	/*	let user = this.auth.getUser()
		let token = '0'
		if(user.permisos.includes('140')) {
			token = token1
		}*/
		return this.http.get<number>(environment.API_SECURITY + '/api/Howen/AlertadosDashboard' )
	}

	obtenerAutosMovimientoHowen() {
		/*let user = this.auth.getUser()
		let token = '0'
		if(user.permisos.includes('140')) {
			token = token1
		}*/
		return this.http.get(`${environment.API_SECURITY}/api/Howen/ContadorMovimiento`)
	}

	obtenerDatosGricaPastel(): Observable<GraficaPastel> {
		/*let user = this.auth.getUser()
		let token = '0'
		if(user.permisos.includes('140')) {
			token = token1
		}*/

		return this.http.get<GraficaPastel>(environment.API_SECURITY + '/api/Dashboard/TotalVehiculos')
	}

	obtenerDatosGraficaBarras(): Observable<any[]> {
		/*let user = this.auth.getUser()
		let token = '0'

		if (user.id == 'c28df0c4-3322-421c-b601-8aa7e80536cf' || user.id == '74bc5a50-65cd-4fa3-9a68-99886b468b6b') {
			token = token1
		}*/

		return this.http.get<any[]>(environment.API_SECURITY + '/api/Dashboard/ReporteVelocidades')
	}

	obtenerAlertasParadas(): Observable<GraficasHw> {
		//Correos de parada no autorizada bitacora BD
		return this.http.get<GraficasHw>(environment.API_SECURITY + '/api/Howen/AlertasBitacora');
	}

	obtenerSaldoPasajero(): Observable<any> {
		//Correos de parada no autorizada bitacora BD
		return this.http.get<any>(environment.API_SECURITY + '/api/Pasajeros/SaldoDashboard');
	}


	obtenerAlertasVideoPuertaAbierta() {
		//Numero de correos de puerta en zona no autorizada
		return this.http.get<GraficasHw>(environment.API_SECURITY + '/api/Howen/AlertasBitacoraPuertaAbierta')
	}

	obtenerAlertasPuertaAbiertaGeneral(): Observable<GraficasHw> {
		//Numero de veces que se abrio la puerta
		return this.http.get<GraficasHw>(environment.API_SECURITY + '/api/Howen/AlertasPuertaAbierta')
	}

	obtenerExcesoVelocidadHW(): Observable<GraficasHw> {
		//Numero de veces a exceso de velocidad
		return this.http.get<GraficasHw>(environment.API_SECURITY + '/api/Howen/ContadorExcesoVelocidad')
	}
}
